<template>
    <div class="d-flex flex-column">
        <div v-for="(itemsByFlask, group) in itemsByGroup" :key="group" :class="{'pb-md-1':(Object.keys(itemsByGroup).length > 1 && group!='C'), 'd-flex align-items-center flex-row':true}">
            <h4 v-if="Object.keys(itemsByGroup).length > 1" class="pr-1 font-weight-semi-bold text-secondary d-none d-md-block">{{group}}</h4>
            <div class="flask-group">
                <div v-for="(value, key) in itemsByFlask" :key="value.flask" :class="{'flask d-flex flex-wrap align-items-center font-weight-semi-bold justify-content-center justify-content-md-start':true}">
                    <div v-if="Object.keys(itemsByFlask).length > 1" class="title text-secondary text-center">{{ flaskLabel(value.flask) }}</div>
                    <flask @select="select" :game-id="gameId" :selected-items="selectedItems" :flask="value" :scrollable="Object.keys(itemsByFlask).length > 1"> </flask>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { groupBy } from "lodash";
import Flask from "./Flask";

export default {
    props: ['gameId', 'selectedItems'],
    components: { Flask },

    data() {
        return {
            flaskGroups: {
                1:'A',
                2:'A',
                3:'B',
                4:'B',
                5:'C',
                6:'C'
            }
        }
    },
    methods: {
        select( {id} ) {
            this.$emit('select', { id });
        },

        flaskLabel(flask) {
            const labels = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V', 6: 'VI' };

            return labels[flask];
        },
    },
    computed: {
        items() {
            const game = Config.games[this.gameId];

            return game && game.items;
        },

        itemsByGroup() {
            if (!this.items)
                return;
            
            const flasked = {};

            for (const [ id, item ] of Object.entries(this.items)) {
                if (!flasked[item.flask])
                    flasked[item.flask] = {};
                
                flasked[item.flask][id] = item;
            }

            let flaskGroups = this.flaskGroups;

            if(Object.keys(flasked).length <= 1) {
                flaskGroups = {1:'A'};
            }

            const grouped = {};

            for (const [ flask, group ] of Object.entries(flaskGroups)) {
                if (!grouped[group]) {
                    grouped[group] = [];
                }

                grouped[group].push({flask:flask, items:flasked[flask]});
            }

            return grouped;
        },
    },
}
</script>

